const Invoices = () => import('./Invoices'),
    Invoice = () => import('./Invoice');

export default [{
    name: 'invoices',
    path: '/admin/invoices/:page',
    component: Invoices,
    props: true,
}, {
    name: 'invoice',
    path: '/admin/invoice/:id',
    component: Invoice,
    props: true,
}];
